import { render, staticRenderFns } from "./tieStallStanchion.vue?vue&type=template&id=4e2f0f8d&"
import script from "./tieStallStanchion.vue?vue&type=script&lang=js&"
export * from "./tieStallStanchion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports